import { render } from "./HeaderApp.vue?vue&type=template&id=3304193f&scoped=true"
import script from "./HeaderApp.vue?vue&type=script&lang=js"
export * from "./HeaderApp.vue?vue&type=script&lang=js"

import "./HeaderApp.vue?vue&type=style&index=0&id=3304193f&scoped=true&lang=css"

import exportComponent from "/var/www/html/AxumWebPage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3304193f"]])

export default __exports__